import React from 'react';
import { IconProps } from './model/IconInterface';

const DatabaseIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <ellipse cx='12' cy='5' rx='9' ry='3' />
        <path d='M3 5v6c0 1.66 4.03 3 9 3s9-1.34 9-3V5' />
        <path d='M3 11v6c0 1.66 4.03 3 9 3s9-1.34 9-3v-6' />
    </svg>
);

export default DatabaseIcon;
